import React, { useEffect } from 'react';
import './ConfirmModal.css';

export default function ConfirmModal({
  isOpen,
  title,
  message,
  confirmText = 'CONFIRM',
  cancelText = 'CANCEL',
  onConfirm,
  onCancel,
  isDangerous = false,
  variant = 'default',
  showCancel = true,
}) {
  useEffect(() => {
    if (!isOpen) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onCancel?.();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onCancel]);

  useEffect(() => {
    if (!isOpen) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel?.();
    }
  };

  const modalVariantClass = variant ? `confirm-modal--${variant}` : '';

  return (
    <div className="confirm-modal-backdrop" onClick={handleBackdropClick}>
      <div
        className={`confirm-modal ${isDangerous ? 'confirm-modal--dangerous' : ''} ${modalVariantClass}`}
        role="dialog"
        aria-modal="true"
        aria-label={title || 'Confirmation'}
      >
        <h2 className="confirm-modal-title">{title}</h2>
        <p className="confirm-modal-message">{message}</p>
        <div className="confirm-modal-buttons">
          {showCancel && (
            <button
              className="confirm-modal-btn confirm-modal-btn--cancel"
              onClick={onCancel}
              type="button"
            >
              {cancelText}
            </button>
          )}
          <button
            className={`confirm-modal-btn confirm-modal-btn--confirm ${
              isDangerous ? 'confirm-modal-btn--dangerous' : ''
            }`}
            onClick={onConfirm}
            type="button"
            autoFocus
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
